<template>
    <div>
        <div class="spacer-30"></div>
        <div class="part-line"></div>
        <div class="main-title">Package Join</div>
        <div class="select-zone-down">
            <a href="#" id="sel_xrp_100" class="" onclick="return false;" v-on:click="selectZone(100);" >$100<br>{{(usdXrpAmt && usdXrpAmt['100']) || '-' }} XRP</a>
            <a href="#" id="sel_xrp_300" class="" onclick="return false;" v-on:click="selectZone(300);" >$300<br>{{(usdXrpAmt && usdXrpAmt['300']) || '-' }} XRP</a>
            <a href="#" id="sel_xrp_500" class="" onclick="return false;" v-on:click="selectZone(500);" >$500<br>{{(usdXrpAmt && usdXrpAmt['500']) || '-' }} XRP</a>
            <a href="#" id="sel_xrp_700" class="" onclick="return false;" v-on:click="selectZone(700);" >$700<br>{{(usdXrpAmt && usdXrpAmt['700']) || '-' }} XRP</a>
            <a href="#" id="sel_xrp_1000" class="select" onclick="return false;" v-on:click="selectZone(1000);" >$1000<br>{{(usdXrpAmt && usdXrpAmt['1000']) || '-' }} XRP</a>
        </div>
        <div class="select-zone">
            <input type="text" name="wallet_address" id="wallet_address" :class="[{'form-control' : true},{'form-control2' : this.isAuthenticated}]" readonly v-model="wallet_address" placeholder="Your Wallet Address">
            <input type="text" name="wallet_balance" id="wallet_balance" class="form-control form-control3" readonly v-model="wallet_balance" placeholder="Balance">
            <a href="" onclick="javascript:return false;" class="btn-refresh" v-on:click="refreshWalletBalance" :disabled="isRefresh === true" ><b-spinner small type="grow" v-if="isRefresh"></b-spinner> </a>
            <a href="" onclick="javascript:return false;" v-on:click="confirmJoinWithUs" :disabled="isLoading === true" class="btn-join"><b-spinner small type="grow" v-if="isLoading"></b-spinner> Join Now</a>
        </div>
        <div class="main-title">Plus 20XRP</div>
        <div class="pd-box-txt" style="padding: 20px 0;">
            The XRP network requires a one-time fee of 20 XRP for account activation<br/>
            When purchasing a package after signing up, please deposit by adding 20XRP to the purchase cost.
        </div>
        <div class="xrp-box" style="margin-top:0px !important;">
            <div class="xrp-txt" v-if="!this.isAuthenticated"><span>ID : </span>-</div>
            <div class="xrp-txt" v-if="this.isAuthenticated"><span>ID : </span>{{ this.user.mem_uuid }}</div>
            <div class="xrp-box-in">
                <div class="xrp-box-img">
                    <svg version="1.1" id="up_00000029038585113215220270000014650171717043181464_"
                         xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 130 90"
                         style="enable-background:new 0 0 130 90;" xml:space="preserve">
                        <g>
					<path class="up-st0" d="M111.5,43.9c0-9.5-7.7-17.1-17.2-17.1c-5,0-9.6,2.2-12.7,5.6c-0.7-2.7-3.2-4.7-6.2-4.7c-0.2,0-0.4,0-0.6,0
						c-0.1-0.5-0.2-1-0.4-1.5C71.5,17,62.8,10.2,52.6,10.2c-12.6,0-22.9,10.2-22.9,22.9c0,0.3,0,0.5,0,0.8c-1.4-0.4-2.8-0.6-4.3-0.6
						c-9.5,0-17.3,7.7-17.3,17.2c0,9.2,7.2,16.7,16.3,17.2v0.1h85.1c6.6,0,12-5.4,12-12C121.5,49.8,117.2,44.9,111.5,43.9z"/>
				</g>
                        <g id="up-arrow">
					<path class="up-st1" d="M66.9,31.7c-0.9-1.4-2.4-1.4-3.3,0l-11,16.6c-0.9,1.4-0.3,2.5,1.3,2.5h6.4v27c0,1.7,1.4,3,3,3h3.8
						c1.6,0,3-1.3,3-3v-27h6.4c1.6,0,2.3-1.1,1.3-2.5L66.9,31.7z"/>
				</g>
				</svg>
                </div>
                <p>Upline Income<br/>
                    {{upline_income}} XRP</p>
            </div>
            <div class="xrp-box-in">
                <div class="xrp-box-img">
                    <svg version="1.1" id="down_00000113345342964579334840000003700125397500493489_"
                         xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 130 90"
                         style="enable-background:new 0 0 130 90;" xml:space="preserve">
				        <g >
					<g>
						<path class="down-st0" d="M110.9,52.4c0-9.5-7.7-17.1-17.2-17.1c-5,0-9.6,2.2-12.7,5.6c-0.7-2.7-3.2-4.7-6.2-4.7c-0.2,0-0.4,0-0.6,0
							c-0.1-0.5-0.2-1-0.4-1.5C71,25.5,62.3,18.7,52,18.7c-12.6,0-22.9,10.2-22.9,22.9c0,0.3,0,0.5,0,0.8c-1.4-0.4-2.8-0.6-4.3-0.6
							c-9.5,0-17.3,7.7-17.3,17.2c0,9.2,7.2,16.7,16.3,17.2v0.1H109c6.6,0,12-5.4,12-12C121,58.3,116.6,53.4,110.9,52.4z"/>
					</g>
                            <g id="down-arrow">
						<path class="down-st1" d="M76.1,44.7h-6.4v-27c0-1.7-1.4-3-3-3h-3.8c-1.6,0-3,1.3-3,3v27h-6.4c-1.6,0-2.3,1.1-1.3,2.5l11,16.6
							c0.9,1.4,2.4,1.4,3.3,0l11-16.6C78.4,45.9,77.7,44.7,76.1,44.7z"/>
					</g>
				</g>
				</svg>
                </div>
                <p>Downline Income<br/>
                    {{downline_income}} XRP</p>
            </div>
            <div class="xrp-box-in">
                <div class="xrp-box-img">
                    <svg version="1.1" id="with_00000021095270910202317090000004279904801388125104_"
                         xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 130 90"
                         style="enable-background:new 0 0 130 90;" xml:space="preserve">
				        <g>
					<g>
						<path class="delete-st0" d="M62.9,6.4H19.3c-1.4,0-2.5,1.1-2.5,2.5v74.2c0,1.4,1.1,2.5,2.5,2.5h62.7c1.4,0,2.5-1.1,2.5-2.5V28L62.9,6.4z"
                        />
                        <g>
							<path class="delete-st1" d="M62.9,25.6c0,1.4,1.1,2.5,2.5,2.5h19.2L62.9,6.4V25.6z"/>
						</g>
					</g>
				</g>
                        <g id="with-arrow">
					<path class="st2" d="M110.1,50.3c1.4-0.9,1.4-2.4,0-3.3L93.5,36c-1.4-0.9-2.5-0.3-2.5,1.3v6.4H64c-1.7,0-3,1.4-3,3v3.8
						c0,1.6,1.3,3,3,3h27V60c0,1.6,1.1,2.3,2.5,1.3L110.1,50.3z"/>
				</g>
				</svg>
                </div>
                <p>Referral Income<br/>
                    {{referral_income}} XRP</p>
            </div>
        </div>
        <div class="spacer-80 pc-mode"></div>
        <div class="spacer-40 mb-mode"></div>
        <div class="main-title">Personal Detail</div>
        <div class="pd-box">
            <div class="pd-input-zone">
                <div class="pd-input-zone-left">
                    <p>Total Package(XRP)</p>
                    <input type="text" name="total_deposit" id="total_deposit" class="form-control input-readonly"  readonly v-model="total_deposit">
                    <div class="spacer-50 pc-mode"></div>
                    <div class="spacer-30 mb-mode"></div>
                    <p>Total Reinvestment Amount(XRP)</p>
                    <input type="text" name="reinvestment_amount" id="reinvestment_amount" class="form-control input-readonly" readonly v-model="reinvestment_amount">
                </div>
                <div class="pd-input-zone-right">
                    <p>Total  Withdrawal(XRP)</p>
                    <input type="text" name="total_withdrawal" id="total_withdrawal" class="form-control input-readonly" readonly v-model="total_withdrawal">
                    <div class="spacer-50 pc-mode"></div>
                    <div class="spacer-30 mb-mode"></div>
                    <p>Withdrawable(XRP)</p>
                    <input type="text" name="total_balance" id="total_balance" class="form-control input-readonly" readonly v-model="total_withdrawable">
                </div>
            </div>
            <div class="pd-img-zone">
                <svg version="1.1" id="man" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 290 360" style="enable-background:new 0 0 290 360;" xml:space="preserve">
                    <ellipse transform="matrix(0.7071 -0.7071 0.7071 0.7071 -104.3939 142.3078)" class="man-st0" cx="119.6" cy="197.2" rx="108.2" ry="108.2"/>
                    <g>
				<path class="man-st1" d="M196.8,113.6c-0.4,0.1-0.8,0.2-1.2,0.3c-8.2,1.3-4.3-5.7-3.1-9.6c0.7-2.2,1.9-4.3,1.8-6.6
					c-0.1-2.4-1.2-4.6-1.3-6.9c-0.1-1.9,0.4-3.8,0.9-5.6c0.4-1.4,0.9-2.8,1.9-3.8c-0.2,0.2,1.2,3.8,1.7,4.1c2.8,1.6,6.9-6.4,8.1-8.1
					c0.3-0.4,0.7-0.9,1.2-1c0.6-0.2,1.3,0.2,2,0c1.8-0.6,2.7-3.2,5.2-2.7c4.3,0.9,4.6,9.1,4,12.3c-1.9,9.8-7.9,17.8-15.4,24
					C200.7,111.4,198.9,112.9,196.8,113.6z"/>
                        <path class="man-st1" d="M197.8,267c0,0.2,0.1,0.3,0.2,0.5c0.8,2.4,1.9,4.6,3.4,6.6c2.2,2.7,5.3,4.8,8.8,5.1c0.3,0,0.7,0,1-0.1
					c1.2-0.4,1.4-1.9,1.2-3.1c-0.3-2-1.4-3.7-1.8-5.7c-0.4-2.3,1-4.5,1.7-6.5c1.9-4.9,3.7-9.9,5.6-14.8c0.3-0.7,0.5-1.5,0.3-2.2
					c-0.3-0.7-0.9-1.1-1.6-1.5c-5.7-3.4-10-7.3-13.2,0.1c-2.2,5-3.5,10.3-4.9,15.5C198,263.3,197.2,264.7,197.8,267z"/>
                        <path class="man-st2" d="M209,270.7c1.2-0.2,2.4-0.4,2.3-0.6c3.6,4.1,7.2,8.3,10.6,12.5c1.3,1.6,4.4,4.3,4.9,6.3
					c0.4,1.8-1.5,2.5-3.5,2.6c-8.7,0.1-20.1-4.4-25.3-11.6c-0.4,0.7-1,1.3-1.7,1.4c-2.1,0.5-5.2-2.4-7-3.3c-0.2-0.1-0.5-0.2-0.6-0.5
					c-0.1-0.2,0-0.5,0.1-0.7c2-4.3,4.4-8.3,7.1-12.2c0.1-0.1,0.2-0.3,0.4-0.3c0.2,0,0.3,0.2,0.4,0.3c1.4,1.9,2.5,3.3,4.6,4.4
					c1.7,0.9,3.8,1.6,5.6,1.8C207.1,270.9,208.1,270.8,209,270.7z"/>
                        <path class="man-st3" d="M133.6,214.6c-7.7-2.1-38.8-11.7-35.6-23.1c1.7-6,14.5-11.8,19.3-15c7.5-5,15.2-9.8,23-14.3
					c2.6-1.5,5.3-3,8.2-3.3c4-0.4,8.4,2.2,12.3,1.4c2.9-0.6,4.2-2.6,6.6-4.2c7-4.7,15.1-8.3,22.6-11.9c15.4-7.4,31.3-13.7,47.6-18.9
					c1.3-0.4,2.7-0.8,4-0.5c1.1,0.3,2.1,1.2,2.9,2c7.5,7.1,15.4,14.9,16.8,25.1c0.8,5.3-0.4,10.8-1.8,16c-3.9,14.3-10.2,27.9-16.4,41.3
					c-8.6,18.5-17.1,37-25.7,55.5c-5.1-2.1-10.3-4.1-15.4-6.2c-1-0.4-2.1-0.9-2.7-1.8c-0.8-1.2-0.7-2.7-0.5-4.2
					c1.7-12.2,3.5-24.4,5.3-36.6c1.7-11.2,5.4-21.2,7.9-32.3c-15.4,15.1-32.5,31.1-54,33.5C150,218,141.6,216.8,133.6,214.6z"/>
                        <path class="man-st1" d="M246.2,333c0.1,0.1,0.2,0.3,0.3,0.4c1.5,2,3.2,3.8,5.2,5.2c2.9,2,6.5,3,9.9,2.2c0.3-0.1,0.7-0.2,0.9-0.4
					c1-0.7,0.8-2.2,0.2-3.3c-0.9-1.8-2.5-3.1-3.4-4.9c-1.1-2-0.4-4.5-0.3-6.8c0.3-5.3,0.6-10.6,0.9-15.8c0-0.8,0.1-1.6-0.4-2.2
					c-0.5-0.6-1.2-0.8-2-1c-6.5-1.6-11.7-4-12.6,4.1c-0.6,5.4-0.2,10.9,0,16.3C245.2,329.4,244.9,331,246.2,333z"/>
                        <path class="man-st2" d="M257.9,333.2c1.1-0.5,2.2-1.1,2-1.2c4.7,2.8,9.3,5.7,13.9,8.8c1.7,1.1,5.5,2.8,6.6,4.5c1,1.6-0.7,2.9-2.5,3.5
					c-8.3,2.8-20.5,1.9-27.7-3.5c-0.1,0.8-0.6,1.5-1.2,1.9c-1.8,1.1-5.7-0.7-7.7-1c-0.2,0-0.5-0.1-0.7-0.3c-0.2-0.2-0.1-0.5-0.1-0.7
					c0.6-4.7,1.7-9.3,3.2-13.7c0.1-0.2,0.1-0.3,0.3-0.4c0.2-0.1,0.4,0,0.5,0.2c1.9,1.4,3.4,2.4,5.7,2.8c1.9,0.3,4.1,0.4,5.9,0
					C256.2,333.9,257.1,333.6,257.9,333.2z"/>
                        <path class="man-st4" d="M208.2,108.9c-2.9-3.2-5.6-6.6-8.7-9.7c-1.1-1.2-6-6.4-7.8-6.1c-0.3,0-0.5,0.2-0.8,0.4
					c-16.2,12.1-31.1,25.5-46.2,39c-4.6,4.1-8,7.5-7,14c0.7,4.9,2.7,9.5,5.7,13.4c12.7,16.7,32.1-12,40.2-20.8
					C185.8,136.8,210.8,111.7,208.2,108.9z"/>
                        <path class="man-st3" d="M127.9,227.6c-8.7-2.3-17.1-6.5-23.5-12.8c-4.4-4.4-12.7-16.4-6.7-21.9c3.9-3.6,10.7-5.5,15.3-8.5
					c6.9-4.6,13.1-10.5,20.7-13.9c8.8-4,19.2-1.7,28.5-1.2c23.2,1.2,46.5,2.4,69.7,3.6c37.1,1.9,31,52.7,32,78.1
					c0.9,21.9,1.8,43.9,0.8,65.9c-0.1,1.3-0.2,2.8-1,3.8c-0.8,0.9-2.2,1.3-3.4,1.5c-7.4,2.1-15-0.4-22.3,0.5
					c-9-33.1-17.5-66.4-25.4-99.9c-14.3,1.3-28.4,4.3-42.7,6c-12.9,1.5-26.1,2.4-38.8-0.3C130,228.2,129,227.9,127.9,227.6z"/>
                        <path class="man-st1" d="M96.6,52.5c1.8,6.3,6.3,12.4,12.6,14.8c-0.8,4.9-2.3,9.6-4.5,14c-0.1,0.3-0.3,0.5-0.2,0.8
					c0.1,0.2,0.3,0.4,0.5,0.6c2.5,2,5.5,3.3,8.6,3.8c3.4,0.6,7.5,0.4,10.7-0.8c0.3-0.1,0.6-0.3,0.8-0.5c0.1-0.2,0.1-0.5,0.1-0.7
					c0.1-5.7-0.3-11.4-1.1-17c0-0.3-0.1-0.7,0-1c0.1-0.2,0.3-0.4,0.5-0.6c2.7-2.3,5-4.9,6.3-8.2c2-5.1,0.8-11.1-1-16
					c-1.8-4.7-4.5-9.9-8.5-12.4c-3.7-2.4-7.9-4.4-12.2-3.6c-3.4,0.6-6.4,3.1-8.5,6.2C97,37.3,94.8,43.2,96,50
					C96.2,50.8,96.4,51.6,96.6,52.5z"/>
                        <path class="man-st5" d="M119.6,47.7c2.1,1.4,3.4,4.5,0.9,6.5"/>
                        <g id="eye02">
					<path class="man-st2" d="M125.1,45c0.9,0.2,1.5,1.1,1.4,1.9c-0.1,0.9-1,1.5-1.9,1.4c-0.9-0.1-1.6-1-1.5-1.8c0.1-0.9,0.9-1.6,1.8-1.6"
                    />
				</g>
                        <g id="eye01">
					<path class="man-st2" d="M113.7,47c0.9,0.2,1.5,1.1,1.4,1.9c-0.1,0.9-1,1.5-1.9,1.4c-0.9-0.1-1.6-1-1.5-1.8c0.1-0.9,0.9-1.6,1.8-1.6"
                    />
				</g>
                        <g id="eyebrow01">
					<path class="man-st5" d="M110.4,44.4c0.9-1.4,2.5-2.2,4.1-1.8"/>
				</g>
                        <g id="eyebrow02">
					<path class="man-st5" d="M122.4,41.8c0.9-0.9,2.3-1.2,3.5-0.8"/>
				</g>
                        <path class="man-st6" d="M124.5,79.5c0.6-1.5,0.6-3.5,0.1-5.8c1.8,0.3,3.6,1,5.1,2c0.7,0.4,1.3,0.9,1.7,1.6c0.4,0.7,0.5,1.6,0.1,2.3
					c-0.2,0.3-0.4,0.6-0.6,0.9c-0.2,0.6,6.4,5.6,7.4,6.8c2.3,3.1,4.1,6.6,5.4,10.2c2.2,5.9,3.7,12.1,5.2,18.3
					c2.1,8.7,4.2,17.4,6.3,26.1c2,8.2,6.3,18.3,6.3,26.7c0.1,14.3-15.9,23.5-27.5,27.7c-11.2,4.1-24.5,5.7-36.2,3.4
					c-1.3-0.2-2.5-0.6-3.6-1.3c-1.1-0.8-1.7-2-2.3-3.1c-2-3.7-4-7.3-6-11c-2.5-4.6-5-9.2-6.9-14.1c-1.3-3.5-2.4-7.1-3.2-10.8
					c-3.4-14.4-4.7-29.3-5.4-44.1c-0.3-6.2-0.5-12.7,2-18.4c1.4-3.4,3.9-6.3,6.4-8.9c-0.9-0.5-2.1-0.1-3.1-0.1
					c-2.3-0.1-3.9-2.8-3.6-5.1c0.3-2.3,1.9-4.2,3.6-5.8c8.2-7.7,19.9-10.8,31.1-10.3c0.8,0,1.6,0.1,2.1,0.8c0.4,0.6,0.3,1.4,0.1,2
					c-0.6,2.5-1.8,4.9-2.4,7.3c-0.9,4.2,5.9,6.1,8.8,6.5C120.3,83.9,123.4,82.5,124.5,79.5z"/>
                        <g id="mouth">
					<path class="man-st5" d="M115.8,57.9c0,0.5,0.6,0.8,1,1c2.8,1,6.3,0,8.1-2.4"/>
				</g>
                        <path class="man-st2" d="M124.8,32.9c0.5,0.6,1,1.2,1.5,2c2-1,3.2-3.3,3.4-5.5c0.2-2.2-0.3-4.5-1.1-6.6c-0.9-2.5-2.1-5-3.9-6.8
					s-4.5-3.1-7.2-2.7c-0.1,0.8-0.7,1.3-1.5,1.6c-0.7,0.2-1.5,0.2-2.3,0.1c-3.8-0.2-7.7,0-11.2,1.5c-1.9,0.8-3.7,2-5.1,3.5
					c-1.5,1.6-1.9,3.5-3,5.3c-0.5,0.8-1.3,1.2-2.1,1.7c-2.4,1.6-4.1,4-5.3,6.6c-1.4,2.9,0.2,6.4,1.4,9.1c0.6,1.2,1.1,2.4,1.7,3.6
					c0.9,1.7,1.8,3.5,3.3,4.8c0.6,0.5,1.3,1,2.2,1.1c1.3,0.2,3.1-0.9,3.8-1.9c1.1-1.5,1.8-4,1.8-5.9c0-2.3,1.1-6.1,3.1-7.4
					c0.2-0.1,0.5-0.3,0.6-0.5c0.2-0.3,0.2-0.6,0.3-1c0.7-5.3,6.7-6.4,11.1-6.4C120.2,29.2,122.6,30.5,124.8,32.9z"/>
                        <path class="man-st1" d="M102.2,45.5c-1-2.4-4.1-2-5.5-0.3c-1.7,2-1.5,4.8,0.4,6.4c1.3,1.1,3.4,1.2,4.4-0.1"/>
                        <path class="man-st7" d="M183.9,110.9l21.4-1.6c2.6-0.2,4.7-2.3,5-4.9l4.3-54.1c0.3-3.3-2.5-6-5.7-5.8l-21.4,1.6
					c-2.6,0.2-4.7,2.3-5,4.9l-4.3,54.1C177.9,108.4,180.6,111.1,183.9,110.9z"/>
                        <g id="hand">
					<path class="man-st1" d="M164.4,118.3c-3-2.5-4.3-5.4-6.7-8.4c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.3,0.3-0.4c2.6-2.6,5.6-4.4,8.2-7
						c1.6-1.6,3.6-3,4.6-5c0.8-1.7,1-3.7,1.5-5.5c0.2-0.8,0.1-1.6,0.5-2.3c0.4-0.9,1-1.6,1.7-2.3c1.2-1.3,2.6-3.3,4.5-3.6
						c0.1,1.2-0.2,2.3-0.1,3.4c0,0.5,0.3,1,0.6,1.3c1.4,1.1,3-0.4,4.2-1.1c1.8-1,3.6-2,5.5-2.9c0.7-0.3,1.5-0.7,2.3-0.5
						c0.8,0.1,1.5,0.9,1.3,1.6c0.7-0.2,1.5-0.4,2.2-0.6c0.9-0.2,2-0.4,2.6,0.3c0.6,0.7,0.2,1.8-0.3,2.6c0.8-0.4,2,0.1,2.3,1
						c0.3,0.9-0.1,2-0.8,2.5c0.4-0.3,0.8,1,0.9,1.2c0.1,0.7-0.1,1.2-0.4,1.8c-0.6,1.2-1.2,2.5-2,3.5c-3.3,4.2-8.3,7.8-12.8,10.6
						c-1.8,1.1-3.8,1.9-5.6,3c-2,1.3-3.2,3-4.6,4.7c-1.3,1.5-2.6,3.1-3.9,4.6c-0.4,0.5-0.9,1-1.5,1.2
						C167.4,121.6,165.2,118.9,164.4,118.3z"/>
                            <path class="man-st6" d="M165.1,99.4c4.3,3.7,8.4,7.7,12.3,11.8c0.8,0.9,1.7,1.8,1.7,3c0,1.1-0.7,2.1-1.3,3
						c-10.3,13.8-20.5,27.6-30.8,41.4c-2,2.7-4.7,5.7-8,5.2c-2.2-0.4-3.9-2.2-5.2-4.1c-3.5-5.1-6-10.9-7.2-17
						c-1.4-7.3-1.6-10.2,4.1-14.9C142.1,118.4,153.6,108.9,165.1,99.4z"/>
                            <path class="man-st8" d="M140.9,117.4c-5.4,3.6-10.7,7.3-16.1,10.9c-0.5,0.3-1,0.7-1.6,0.8c-1.1,0.1-2.1-0.7-2.9-1.5
						c-5.7-5.5-11.5-10.9-17.2-16.4"/>
                            <path class="man-st8" d="M99.8,154.6c5.6,4.9,11.6,10,18.9,11.1c5.3,0.8,10.7-0.6,15.5-3c4.8-2.4,9-5.7,13.2-9.1"/>
				</g>
                        <path class="man-st9" d="M252.2,196.4c-7.9,17.5-16.1,34.7-24.7,51.8"/>
                        <path class="man-st9" d="M209.4,167.6c-1.5,12.8-3.1,25.5-4.6,38.3"/>
                        <path class="man-st9" d="M183.4,170.8c8.5,0.2,16.9,0.5,25.4,0.7"/>
			</g>
			</svg>
            </div>
        </div>
        <div class="row">
            <modal :show.sync="modals.notificationShow"
                   gradient="danger"
                   modal-classes="modal-warning modal-dialog-centered modal-title-notification">
                <h6 slot="header" class="modal-title" id="modal-title-notification">Your attention is required</h6>

                <div class="py-3 text-center">
                    <img src="/img/common/join_with.png"/>
                    <div class="heading mt-4">
                        {{ notificationMessage }}
                        <br/>
                        {{ notificationSubMessage }}
                    </div>
                </div>

                <template slot="footer">
                    <!--<base-button type="white">Ok, Got it</base-button>-->
                    <base-button type="link"
                                 text-color="white"
                                 class="ml-auto"
                                 @click="modals.notificationShow = false">
                        Close
                    </base-button>
                </template>
            </modal>
            <modal :show.sync="modals.confirmationShow"
                   modal-classes="modal-info modal-dialog-centered modal-title-notification ">
                <h6 slot="header" class="modal-title" id="modal-title-confirmation">Your confirmation is required</h6>

                <div class="py-3 text-center">
                    <img src="/img/common/join_with.png"/>
                    <h4 class="heading mt-4">{{ confirmationMessage }}</h4>
                </div>

                <template slot="footer">
                    <base-button type="white" class="modal-confirm-btn"
                                 v-on:click="joinWithUs">Ok, Got it</base-button>
                    <base-button type="link"
                                 text-color="white"
                                 class="ml-auto"
                                 @click="modals.confirmationShow = false">
                        Close
                    </base-button>
                </template>
            </modal>
            <modal :show.sync="modals.info"
                   modal-classes="modal-info modal-dialog-centered modal-title-notification">
                <h6 slot="header" class="modal-title" id="modal-title-confirmation">Success!</h6>
                <p>
                    {{ infoMessage }}
                </p>
                <p>
                    {{ infoSubMessage }}
                </p>
                <template v-slot:footer>
                    <base-button
                            type="link"
                            text-color="white"
                            class="ml-auto"
                            @click="modals.info = false"
                    >Close</base-button>
                </template>
            </modal>
        </div>
    </div>
</template>
<style>
    .btn-refresh {
        text-align:center;

    }
    .spinner-grow {
        margin: auto 0;
    }
    .modal-info > .modal-content {
        background-color: #6097e6 !important;
    }
    .modal-warning > .modal-content {
        border: 0px !important;
    }
    .select-zone-down {
        padding: 50px 0 20px 0 !important;
    }
    .select-zone {
        padding: 0px 0px 0px 0px !important;
    }
</style>
<script>

import {mapGetters} from "vuex";
import axios from "../../service/axios";
import Modal from "@/components/Modal.vue";
export default {
    components: {
        Modal
    },
    data: () =>{
        return {
            isLoading: false,
            isRefresh: false,
            modals: {
                info: false,
                notificationShow: false,
                confirmationShow: false,
            },
            confirmationMessage : '',
            notificationMessage : '',
            notificationSubMessage : '',
            infoMessage: '',
            infoSubMessage: '',
            usdXrpAmt: {},
        }
    },
    computed: {
        ...mapGetters(["isAuthenticated"]), /* store에 저장된 값을 가져온다. */
        ...mapGetters(["detail"]),  /* store에 저장된 값을 가져온다. */
        ...mapGetters(["user"]), /* store에 저장된 값을 가져온다. */
        upline_income: function () {
            if (this.isAuthenticated) {
                return this.detail.upline_income;
            } else {
                return "-";
            }
        },
        downline_income: function () {
            if (this.isAuthenticated) {
                return this.detail.downline_income;
            } else {
                return "-";
            }
        },
        referral_income: function () {
            if (this.isAuthenticated) {
                return this.detail.total_referral;
            } else {
                return "-";
            }
        },
        total_withdrawable: function () {
            if (this.isAuthenticated) {
                return this.detail.withdrawable;
            } else {
                return "-";
            }
        },
        total_deposit: function () {
            if (this.isAuthenticated) {
                return this.detail.total_deposit;
            } else {
                return "0";
            }
        },
        total_withdrawal: function () {
            if (this.isAuthenticated) {
                return this.detail.total_withdrawal;
            } else {
                return "0";
            }
        },
        reinvestment_amount: function () {
            if (this.isAuthenticated) {
                return this.detail.reinvestment_amount;
            } else {
                return "0";
            }
        },
        total_balance: function () {
            if (this.isAuthenticated) {
                return this.detail.total_balance;
            } else {
                return "0";
            }
        },
        wallet_address: function() {
            if (this.isAuthenticated) {
                return this.detail.xrp_wallet;
            } else {
                return "";
            }
        },
        wallet_balance: function() {
            if (this.isAuthenticated) {
                return this.detail.xrp_balance;
            } else {
                return "";
            }
        }
    },
    watch: {
        '$store.state.detail': function() {
            // for refreshWalletBalance()
            // state에서 상태변화를 모니터링 한다. 변화되었다면 refresh플래그를 꺼준다.
            this.isRefresh = false;
        }
    },
    mounted() {
        //console.log("joinwidthus - mounted");
        this.getUsdXrpRate();
        if (this.isAuthenticated) {
            this.$store.dispatch("setDetail");
        }
    },
    methods: {
        getUsdXrpRate: function () {
            return new Promise((resolve, reject) => {
                axios
                    .get("/account/v1/rate/info")
                    .then(response => {
                      const status = response.data.status;
                      this.usdXrpAmt = response.data.usdXrpAmt;
                      if (response.data.status === 'f') {
                        this.usdXrpAmt = null;
                      }
                      resolve(response)
                    })
                    .catch(error => {
                      reject(error)
                    })
            })
        },
        getSafeFloat : function(value) {
            let strVal = value + '';
            strVal = strVal.replace(/,/g, '');
            return Number.parseFloat(strVal);
        },
        confirmJoinWithUs: function () {
            this.notificationSubMessage = '';
            if (!this.isAuthenticated) {
                this.notificationMessage = "You are not logged in. Please log in and try again";
                this.modals.notificationShow = true;
                return ;
            }
            if (this.isLoading) {
                return;
            }
            if (!this.wallet_address) {
                this.notificationMessage = "Please, Enter your wallet address.";
                this.modals.notificationShow = true;
                return ;
            }
            if (this.selectXrp() > this.wallet_balance) {
                this.notificationMessage = "Insufficient XRP balance to send.";
                this.modals.notificationShow = true;
                return;
            }
            const expectDeposit = this.getSafeFloat(this.total_deposit) + this.selectXrp();
            const depositable = 1000 - this.getSafeFloat(this.total_deposit);
            // (이미 입금한 금액 + 입금할 금액) 이 1000이 넘으면 입금이 안된다.
            if (expectDeposit > 1000) {
                this.notificationMessage = "Maximum investment amount exceeded (1000 XRP).";
                this.notificationSubMessage = "You can deposit " + depositable + " XRP." ;
                this.modals.notificationShow = true;
                return;
            }
            this.confirmationMessage = 'Will you join with us now?';
            this.modals.confirmationShow = true;

        },
        refreshWalletBalance :function () {
            if (!this.isAuthenticated) {
                return;
            }
            this.isRefresh = true;
            this.$store.dispatch("setDetail");
        },
        joinWithUs: function () {
            if (!this.isAuthenticated) {
                return;
            }

            this.modals.confirmationShow = false;
            this.isLoading = true;
            const data = {
                amount: this.selectXrp(),
                amount_usd: this.selectUsd(),
                wallet_address: this.wallet_address,
            };

            // JWT-Token Expired check
            axios
                .post("/auth/v1/verifyToken")
                .then(response => {})
                .catch(error => {
                    console.log(error)
                });
            axios
                .post("/xrp/v1/joinwithus", data)
            .then(response => {
                this.isLoading = false;
                //console.log(response.data)
                if (response.data.status === 'f') {
                    this.notificationMessage = response.data.message;
                    this.modals.notificationShow = true;
                } else {
                    this.infoMessage = 'The investment was successful.';
                    this.infoSubMessage = "TX-KEY : " + response.data.tx_hash;
                    this.modals.info = true;
                    // 해시키값(송금 - 트랜잭션키)를 클립보드로 복사해 준다.
                    this.copyToClipboard(response.data.tx_hash);
                    this.$store.dispatch("setDetail");
                }
            })
            .catch(error => {
                console.log(error)
                this.isLoading = false;
                this.notificationMessage = error;
                this.modals.notificationShow = true;
            });
        },
        copyToClipboard : function (val) {
            const t = document.createElement("textarea");
            document.body.appendChild(t);
            t.value = val;
            t.select();
            document.execCommand('copy');
            document.body.removeChild(t);
        },
        selectZone : function(xrp) {
            //console.log('selectZone');
            const clickedId = "sel_xrp_" + xrp;
            const xrps = [100,300,500,700,1000];
            // clear all
            xrps.forEach(function(element){
                let curId = "sel_xrp_" + element;
                $("#" + curId).removeClass('select');
            });
            $("#" + clickedId).addClass('select');
        },
        selectXrp: function () {
            const usdList = [100,300,500,700,1000];
            // clear all
            let sel_usd = 100;
            usdList.forEach(function(element){
                let curId = "sel_xrp_" + element;
                if ($("#" + curId).hasClass('select')) {
                  sel_usd = element;
                }
            });
            let sel_xrp = 0;
            if (this.usdXrpAmt && this.usdXrpAmt[sel_usd]) {
              sel_xrp = this.usdXrpAmt[sel_usd];
            }
            return sel_xrp;
        },
        selectUsd: function () {
            const usdList = [100,300,500,700,1000];
            // clear all
            let sel_usd = 100;
            usdList.forEach(function(element){
              let curId = "sel_xrp_" + element;
              if ($("#" + curId).hasClass('select')) {
                sel_usd = element;
              }
            });
            return sel_usd;
        },
    }
};
</script>
<style>
</style>
